import { Component, OnInit } from '@angular/core';
import {DxAuthService} from "../../../../dx-auth/services/dx-auth.service";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";
import {ActivatedRoute, Router} from "@angular/router";
import {DxModalService} from "../../../../dx-modals/services/dx-modal.service";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'pit-welcome-page',
  templateUrl: './pit-welcome-page.component.html',
  styleUrls: ['./pit-welcome-page.component.css']
})
export class PitWelcomePageComponent implements OnInit {

  constructor(private _authService: DxAuthService,
              private _router: Router,
              private activeRoute: ActivatedRoute,
              private modalService: DxModalService) { }

  ngOnInit() {
    const errorMessage = this.activeRoute.snapshot.queryParams.errorMessage;
    if (errorMessage) {
      this.modalService.showError(errorMessage).subscribe();
    }
  }

  onStartButtonClick(): void {
    const login = this.activeRoute.snapshot.queryParams.login;
    if (environment.stand === 'local' && !login) {
      this.modalService.showError('Пользователь неизвестен').subscribe();
      return;
    }
    this._authService.login(login, null).subscribe(auth => {
      // if(DxOperationResultType.SUCCESS == auth.authResult) {
      //   this._router.navigate(['/navigator/tasks']).then();
      // } else {
      //   this.modalService.showError('Чего-то не получается войти :(').subscribe();
      // }
    });
  }

}
